<!-- 复选框、单选框、下拉框 -->
<template>
  <el-checkbox-group
    v-if="type === 'checkbox'"
    v-model="lzdKey"
    v-bind="attrs"
    :readonly="readonly"
    @change="change"
  >
    <el-checkbox v-for="(v, index) in options" :key="index" :value="v.v">
      {{ !labelFn ? (v.l ?? v.v!) : labelFn(v) }}
    </el-checkbox>
  </el-checkbox-group>
  <el-radio-group
    v-else-if="type === 'radio'"
    v-model="lzdKey"
    v-bind="attrs"
    :readonly="readonly"
    @change="change"
  >
    <el-radio v-for="(v, index) in options" :key="index" :value="v.v">
      {{ !labelFn ? (v.l ?? v.v!) : labelFn(v) }}
    </el-radio>
  </el-radio-group>
  <el-select
    v-else
    v-model="lzdKey"
    v-bind="attrs"
    :readonly="readonly"
    :remote-method="remoteMethod"
    :placeholder="readonly ? '' : (placeholder ?? '')"
    @change="change"
  >
    <!-- 20260910 value值改为只显示value -->
    <!-- <el-option
      v-for="v in options"
      :key="v.k"
      :value="v.v!"
      :label="!labelFn ? (v.l ?? v.v!) : labelFn(v)!"
      v-show="!showData || showData == v.item"
    /> -->
    <el-option
      v-for="v in options"
      :key="v.k"
      :value="v.k ?? v.v!"
      :label="!labelFn ? (v.l ?? v.v!) : labelFn(v)!"
      v-show="!showData || showData == v.item"
    />
  </el-select>
</template>

<script lang="ts" setup>
  import { useAttrs, ref, onMounted, watch } from 'vue';
  import type { KV } from '@/api';

  type E = KV;

  defineOptions({ name: 'LzdKvSelect' });
  const options = ref<E[]>([]);
  const props = withDefaults(
    defineProps<{
      type?: 'select' | 'radio' | 'checkbox';
      readonly?: boolean;
      placeholder?: string;
      /** 选项集合 */
      items?: E[];
      itemsFn?: () => Promise<E[]>;
      remoteFn?: (keyword: string) => Promise<E[]>;
      /** 构造显示文本 */
      labelFn?: (item: E) => string;
      /** 判断数据显示 */
      showData?: string;
    }>(),
    { placeholder: '请选择' }
  );

  const emit = defineEmits<{
    (e: 'change', value: any): void;
  }>();

  /** 键 */
  const lzdKey = defineModel<any>('lzd-k');

  /** 值 */
  const lzdValue = defineModel<any>('lzd-v');

  const attrs = useAttrs();
  const change = (k: any) => {
    if (Array.isArray(k)) {
      const results = options.value.filter((item) => k.includes(item.k));
      if (!results || results.length === 0) {
        lzdValue.value = void 0;
      }
      emit('change', results);
    } else {
      const result = options.value.find((item) => item.k === k);
      lzdValue.value = result?.v;
      emit('change', result);
    }
  };

  const remoteMethod = async (keyword: string) => {
    if (!props.remoteFn) return;
    options.value = (await props.remoteFn(keyword)) ?? [];
  };

  watch(
    () => props.items,
    async (items) => {
      options.value = items ?? [];
    }
  );

  watch(
    () => props.itemsFn,
    async (itemsFn) => {
      if (itemsFn) {
        options.value = (await itemsFn()) ?? [];
      }
    }
  );

  onMounted(async () => {
    if (props.itemsFn) {
      options.value = (await props.itemsFn()) ?? [];
    } else {
      options.value = props.items ?? [];
    }
  });
</script>
